import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.CustomerDecisionSection', {
    sectionTitle: 'Make a decision on Quote',
    declineButtonTitle: 'Decline',
    acceptButtonTitle: 'Accept',
});
